var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Recycle Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-item-recycle-mode", {
                        attrs: { model: _vm.mode },
                        on: {
                          "update:model": function ($event) {
                            _vm.mode = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    {
                      model: {
                        value: _vm.panels,
                        callback: function ($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels",
                      },
                    },
                    [
                      _c("r-reward-panel", {
                        attrs: {
                          disabled: _vm.mode.id < 2,
                          model: _vm.model.reward,
                          title: "Rewards",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "reward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }